import script from "./PlansAndPricing.vue?vue&type=script&setup=true&lang=js"
export * from "./PlansAndPricing.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__